import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderMenuLink, HeaderMenuSection, HeaderMenuService } from '../header-menu.service';

@Component({
    selector: 'app-header-quick-links',
    templateUrl: './header-quick-links.component.html',
    styleUrls: ['./header-quick-links.component.css']
})
export class HeaderQuickLinksComponent implements OnInit {
    sections: HeaderMenuSection[] = [];
    showPanel = false;

    constructor(private headerMenuService: HeaderMenuService, private router: Router) { }

    ngOnInit(): void {
        this.headerMenuService.loadMenus();
        this.sections = this.headerMenuService.getSections();
    }

    togglePanel(event: Event): void {
        event.stopPropagation();
        this.showPanel = !this.showPanel;
    }

    closePanel(): void {
        this.showPanel = false;
    }

    navigate(link: HeaderMenuLink): void {
        this.showPanel = false;

        if (link.qsParameters) {
            this.router.navigate([link.path], { queryParams: { q: link.qsParameters } });
        } else {
            this.router.navigate([link.path]);
        }
    }

    goDashboard(): void {
        this.showPanel = false;
        this.router.navigate(['/Dashboard']);
    }

    goModules(): void {
        this.showPanel = false;
        this.router.navigate(['/Modules']);
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (!target.closest('.header-quick-links-wrap') && !target.closest('.header-quick-panel')) {
            this.showPanel = false;
        }
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (event.keyCode === 27) {
            this.showPanel = false;
        }
    }
}
